const STORAGE_PREFIX = 'elda.smartSearch.recentQueries.'

function parseStored(raw: string | null): string[] {
  if (!raw) return []
  try {
    const v = JSON.parse(raw) as unknown
    if (!Array.isArray(v)) return []
    return v.filter((x): x is string => typeof x === 'string')
  } catch {
    return []
  }
}

export function readRecentSearchQueries(
  resortId: number | undefined,
): string[] {
  if (resortId == null || typeof window === 'undefined') return []
  return parseStored(window.localStorage.getItem(STORAGE_PREFIX + resortId))
}

// remember a query after successful navigation (max ~12 entries per station)
export function rememberSearchQuery(
  resortId: number | undefined,
  raw: string,
): void {
  if (resortId == null || typeof window === 'undefined') return
  const q = raw.trim()
  if (q.length < 2 || q.length > 240) return

  let list = readRecentSearchQueries(resortId).filter(
    x => x.toLowerCase() !== q.toLowerCase(),
  )
  list.unshift(q)
  list = list.slice(0, 12)
  try {
    window.localStorage.setItem(STORAGE_PREFIX + resortId, JSON.stringify(list))
  } catch {
    /* quota / private mode */
  }
}

/** Filtre les récents pour l’autocomplétion (préfixe insensible à la casse). */
export function filterRecentForPrefix(
  queries: string[],
  prefix: string,
  limit = 6,
): string[] {
  const p = prefix.trim().toLowerCase()
  if (!p) return queries.slice(0, limit)
  return queries.filter(q => q.toLowerCase().startsWith(p)).slice(0, limit)
}
